import {
  SCREEN_NAMES_FOR_DIGITAL_DATA,
  TITLE_VCD,
  DESCRIPTION_VCD,
  TITLE_VCD_UNIVERSITARIO,
  DESCRIPTION_VCD_UNIVERSITARIO,
  TITLE_VD_PLUS,
  TITLE_VE,
  TITLE_VIAJES,
  URL_VCD,
  URL_VD_PLUS,
  URL_VE,
  URL_VIAJES,
  DESCRIPTION_VE,
} from "./consts";
import helpers from "./helpers";

const getHomePath = (pathname) => `/comprar/${pathname}`;

export const getProductOptions = () => {
  const isVidaPlus = helpers.validateVidaPlus();
  const isViajes = helpers.validateViajes();
  const isVidaEndosable = helpers.validateVidaEndosable();
  const isVidaUniversitario =
    new URLSearchParams(window.location.search).get("version") ===
    "universitario";

  if (isVidaEndosable) {
    return {
      homePath: getHomePath(URL_VE),
      pageTitle: TITLE_VE,
      title: "Vida Endosable 100% Digital",
      pageDescription: DESCRIPTION_VE,
      productName: URL_VE,
      digitalDataProductName: "Seguro Vida Endoso con Devolución",
      appId: process.env.REACT_APP_ID_INSTANA_VE,
    };
  }

  if (isVidaPlus) {
    return {
      homePath: getHomePath(URL_VD_PLUS),
      pageTitle: TITLE_VD_PLUS,
      title: "Vida Plus",
      productName: URL_VD_PLUS,
      digitalDataProductName: "Seguro Vida Plus",
      appId: process.env.REACT_APP_ID_INSTANA_VPLUS,
    };
  }

  if (isViajes) {
    return {
      homePath: getHomePath(URL_VIAJES),
      pageTitle: TITLE_VIAJES,
      title: "Seguro de Viajes",
      productName: URL_VIAJES,
      digitalDataProductName: "Seguro Viajes",
      appId: process.env.REACT_APP_ID_INSTANA_VIAJES,
    };
  }

  return {
    homePath: getHomePath(URL_VCD),
    pageTitle: isVidaUniversitario ? TITLE_VCD_UNIVERSITARIO : TITLE_VCD,
    pageDescription: isVidaUniversitario
      ? DESCRIPTION_VCD_UNIVERSITARIO
      : DESCRIPTION_VCD,
    title: "Vida Ahorro con Devolución",
    productName: URL_VCD,
    digitalDataProductName: "Seguro Vida Devolución Garantizada",
    appId: process.env.REACT_APP_ID_INSTANA_VCD,
  };
};

export const getScreenName = () => {
  const { homePath } = getProductOptions();
  const pathname = window.location.pathname.replace(homePath, "");
  return SCREEN_NAMES_FOR_DIGITAL_DATA[pathname] ?? "";
};
